import type { AssignmentSubmissionSchema } from '@repo/schemas/assignment/assignmentSubmission';

export const ASSIGNMENT_RESOLVE_EMPTY_VALUES: AssignmentSubmissionSchema = {
  body: '',
};

export const ASSIGNMENT_RESOLVE_DRAFT_WRITE_DEBOUNCE_MS = 300;

export const ASSIGNMENT_RESOLVE_DRAFT_MAX_AGE_MS = 7 * 24 * 60 * 60 * 1000;
